<template>
  <b-modal
    v-model="localIsActive"
    size="lg"
    hide-footer
    no-close-on-esc
    no-close-on-backdrop
    @show="onShow"
    @hide="onHide"
  >
    <template #modal-title>
      Validar video tour
    </template>
      <div  ref="swiperContainer" class="swiper carrousel-layout-view">
        <!-- Additional required wrapper -->
        <div class="swiper-wrapper">
          <!-- Slides -->
          <div
            v-for="(view, index) in viewsSelected"
            :key="index"
            class="swiper-slide"
          >
            <div class="row mx-0 justify-content-center">
              <div class="col-10">
                <LayoutViews
                  style="height: 200px;"
                  :view="view"
                  :showMoveControls="false"
                  :showAddControl="false"
                />
              </div>
            </div>
            <p class="mb-0 text-center mt-1">
              {{ index + 1 }} / {{ viewsSelected.length }}
            </p>
          </div>
        </div>
        <!-- If we need pagination -->
        <div class="swiper-pagination"></div>

        <!-- If we need navigation buttons -->
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
      <!-- <Carousel
        v-if="carouselReady"
        navigationEnabled
        :paginationEnabled="false"
        :per-page="1"
      >
        <Slide
          v-for="(view, index) in viewsSelected"
          :key="index"
        >
          <div >
            <div class="row justify-content-center">
              <div class="col-8">
                <LayoutViews
                  style="height: 200px;"
                  :view="view"
                  :showMoveControls="false"
                  :showAddControl="false"
                />
                <p class="mb-0 text-center mt-1">
                  {{ index + 1 }} / {{ viewsSelected.length }}
                </p>
              </div>
            </div>
          </div>
        </Slide>
      </Carousel> -->
    <div v-if="showComments">
      <h5 class="my-1">Comentario anterior</h5>
      <p class="mb-0">
        {{ videoTour.comments }}
      </p>
    </div>
    <b-form-group
      v-if="!isVideoTourCommentedType"
      label="Comentarios"
      label-for="comments"
      class="mt-1"
      rows="8"
      max-rows="8"
    >
      <b-form-textarea
        id="comments"
        v-model="comments"
        :class="isCommentsInvalid"
        placeholder="Ingresar texto"
        :plaintext="isVideoTourCommentedType"
      ></b-form-textarea>
      <div v-if="errorComments" class="text-danger">
        {{ errorComments }}
      </div>
    </b-form-group>
     <div class="d-flex justify-content-end">
        <b-button
          v-if="isVideoTourCommentedType"
          variant="primary"
          :disabled="loadingAction"
          @click="openVideoTour()"
        >
          Abrir video tour
        </b-button>
        <b-button
          v-if="showValidatorButtons"
          variant="primary"
          :disabled="loadingAction"
          @click="addComments()"
        >
          Agregar comentarios
        </b-button>
        <b-button
          v-if="showValidatorButtons"
          class="mx-1"
          variant="danger"
          :disabled="loadingAction"
          @click="rejectVideoTour()"
        >
          Rechazar
        </b-button>
        <b-button
          v-if="showValidatorButtons"
          variant="success"
          :disabled="loadingAction"
          @click="videoTourValidate()"
        >
          Validar
        </b-button>
    </div>
  </b-modal>
</template>

<script>
import axios from '@axios';
import { computed, getCurrentInstance, nextTick ,ref, onBeforeUnmount } from '@vue/composition-api';
import PreviewLayout from '@/views/alarm_views/layout/PreviewLayout.vue';
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { useToast } from "vue-toastification/composition";
import LayoutViews from './LayoutViews.vue';
import Swiper from "swiper/swiper-bundle.mjs";
import "swiper/swiper-bundle.css";

export default {
  props: {
    videoTour: {
      type: Object
    },
    showModalVideoTour:{
      type: Boolean
    }
  },
  components: {
    LayoutViews,
    PreviewLayout,
  },
  setup(props, { emit }) {
    const vm = getCurrentInstance().proxy;

    //HOOKS
    onBeforeUnmount(() => {
      if (swiper.value) {
        swiper.value.destroy(true, true);
        swiper.value = null;
      }
    });

    //COMPOSABLES
    const toast = useToast();

    //DATA
    const carouselReady = ref(false);

    const comments = ref(null);

    const currentPreview = ref(null);

    const errorComments = ref(null);

    const loading = ref(false);

    const loadingAction = ref();

    const refPreviewLayout = ref(null);

    const swiper = ref(null);

    const swiperContainer = ref(null);

    //COMPUTED
    const localIsActive = computed({
      get() {
        return props.showModalVideoTour;
      },
      set(value) {
        emit("update:isActive", value);
      },
    });

    const isCommentsInvalid = computed(() => errorComments.value ? 'is-invalid' : '');

    const isVideoTourCommentedType = computed(() => props.videoTour.type === 'video_tour_commented');

    const viewsSelected = computed(() => {
      if (!props.videoTour.config) {
        return [];
      }

      const config = props.videoTour.config;
      const posMap = Object.fromEntries(config.map(p => [p.id, p.position]));
      const result = props.videoTour.video_tour.views
      .filter(view => posMap[view.id] !== undefined)
      .map(view => ({
        ...view,
        position: posMap[view.id]
      }))
      .sort((a, b) => a.position - b.position);

      return result;
    });

    const showValidatorButtons = computed(() => !isVideoTourCommentedType.value && vm.$can('validate', 'VideoTour'));

    const showComments = computed(() => (props.videoTour && props.videoTour.comments));

    //METHODS
    const addComments = () => {
      errorComments.value = null;

      if (!comments.value) {
        errorComments.value = 'El campo comentarios es requerido';
        return;
      }

      loadingAction.value = true;

      const id_video_tour = props.videoTour.id_video_tour;
      const payload = {
        comments: comments.value
      }

      axios.patch(`v1/video-tours/${id_video_tour}/add-comments`, payload)
        .then(response => {
          const { data } = response;

          toast({
            component: ToastificationContent,
            props: {
              title: data.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          });

          comments.value = null;

          emit('video-tour-commented', props.videoTour.id);
          emit('video-tours-with-comments');

          onHide();
        })
        .catch(error => {
          const { message = 'error' } = error.response.data;

          toast({
            component: ToastificationContent,
            props: {
              title: message,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          });
        })
        .finally(() => {
          loadingAction.value = false;
        });
    }

    const onHide = () => {
      emit('update:isActive', false);
    }

    const onShow = async () => {
      carouselReady.value = false

      await nextTick();

      setTimeout(() => {
        carouselReady.value = true
        window.dispatchEvent(new Event('resize'))

        if (!swiperContainer.value) {
          return;
        }

        swiper.value = new Swiper(swiperContainer.value, {
          slidesPerView: 1,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }
        });
      }, 60);
    }

    const openVideoTour = () => {
      emit('open-video-tour-modal');
      onHide();
    }

    const rejectVideoTour = async () => {
      errorComments.value = null;

      if (!comments.value) {
        errorComments.value = 'El campo comentarios es requerido';
        return;
      }

      const id_video_tour = props.videoTour.id_video_tour;
      const payload = {
        comments: comments.value
      }

      loadingAction.value = true;

      await axios.patch(`v1/video-tours/${id_video_tour}/reject`, payload)
        .then(response => {
          const { data } = response;

          toast({
            component: ToastificationContent,
            props: {
              title: data.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          });

          /* store.dispatch("grid/getUserViews", { max: 4, currentPage:1 }); */
          emit('video-tour-rejected', props.videoTour.id);
          onHide();
        })
        .catch(error => {
          const { message = 'error' } = error.response.data;

          toast({
            component: ToastificationContent,
            props: {
              title: message,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          });
        })
        .finally(() => {
          loadingAction.value = false;
        });
    }


    const videoTourValidate = async () => {
      const id_video_tour = props.videoTour.id_video_tour;

      loadingAction.value = true;

      await axios.get(`v1/video-tours/${id_video_tour}/validate`)
        .then(response => {
          const { data } = response;

          toast({
            component: ToastificationContent,
            props: {
              title: data.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          });

          //store.dispatch("grid/getUserViews", { max: 4, currentPage:1 });
          emit('video-tour-validated', props.videoTour.id);
          onHide();
        })
        .catch(error => {
          const { message = 'error' } = error.response.data;

          toast({
            component: ToastificationContent,
            props: {
              title: message,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          });
        })
        .finally(() => {
          loadingAction.value = false;
        });
    }

    return {
      carouselReady,
      comments,
      currentPreview,
      errorComments,
      loading,
      loadingAction,
      refPreviewLayout,
      swiperContainer,

      localIsActive,
      isCommentsInvalid,
      isVideoTourCommentedType,
      showValidatorButtons,
      showComments,
      viewsSelected,

      addComments,
      onHide,
      onShow,
      openVideoTour,
      rejectVideoTour,
      videoTourValidate
    }
  }
}
</script>

<style scoped>
.carrousel-layout-view .swiper-button-prev,
.carrousel-layout-view .swiper-button-next {
  color: #1c3d5e;
}

.carrousel-layout-view .swiper-button-prev::after,
.carrousel-layout-view .swiper-button-next::after {
  font-size: 24px;
  font-weight: bold;
}
</style>

